import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageLink'
})
export class ImageLinkPipe implements PipeTransform {
  constructor(@Inject('env') private _env: any) {}
  transform(value: string): string {
    return `${this._env.apiURL}/Files/GetFile/${value}`;
  }
}
